import { ApplicationConfig, isDevMode, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';

import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http'
import { provideAuth } from './core/auth/auth.provider';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideServiceWorker } from '@angular/service-worker';


export const appConfig: ApplicationConfig = {
  providers: [
      provideHttpClient(),
        provideZoneChangeDetection({ eventCoalescing: true }), provideRouter(routes),provideAnimations(),
        provideAuth(),
          provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
          }),
        
  ]
};


